<!--summary-->
<ng-container *ngIf="globals.Session">
    <app-view (viewSelectedChanged)="onViewChange($event)" (showSideBar)="toggleSidebar($event)" [refreshView]="refreshView"></app-view>
</ng-container>
<div [ngClass]="{'primary-content' : true, 'pad': smallPad, 'full-pad' : true}">
  
  <div *ngIf="globals.Session">
    <app-searchbar (keywordChanged)='onSearchKeywordChange($event)' [keyword]='searchKeyword' [setPlaceholder]="summaryName"></app-searchbar>
    <div [ngClass]="{'navigation-bar': true, 'space': !onMobile }">
      <div class="content-toggle" style="padding: 5px;position: absolute;top: -5px;right: 2px;" title="Back to summary list">
          <a href="javascript:void(0)" class="content-toggle-btn" (click)="switchSummary()">
            <fa name="arrow-circle-left" class="content-toggle-btn-ic" style="font-size: 1.5rem;"></fa>
          </a>
      </div>
    </div>
    <div class="container-fluid">
      <div class="row">
        <div [ngClass]="{'docSummaryPanel custom-scrollbar' : true, 'open': smallSum, 'hide': onMobile}">
          <app-summary #summary [componentId]="componentId" [documentType]="documentType" [documentSummaryName]="documentSummaryName" 
            (selectedId)='onSelectedItem($event)'
          [keyword]="searchKeyword"
          (refreshView)="forceRefreshView()" (toggleSummary)="toggleSummary()" (setSummaryName)="setSummaryName($event)"></app-summary>
        </div>
        <div [ngClass]="{'docDetailPanel open': true, 'custom-scrollbar': true, 'full': fullDetail }">
          <app-detail #detail [setComponentId]='selectedDetailId' [documentType]='selectedDetailType' 
          (selectedSubItemId)="onSelectedSubItemId($event)" (selectedSubItemType)="onSelectedSubItemType($event)"></app-detail>
        </div>
        <app-detail #subDetail [setComponentId]='selectedSubDetailId' [documentType]='selectedSubDetailType'></app-detail>
      </div>
    </div>
    
  </div>
</div>
